import { GuestPortalMemberInfo, PortalMemberInfo } from './PortalMemberInfo';
import { PortalEligibilityData } from 'api/src/dataModels/PortalEligibilityData';
import {
  PortalIdentifier,
  PortalSource,
} from 'api/src/dataModels/PortalDataEnums';

export interface PortalUrl {
  name: string;
  urlPath: string;
}

export interface PortalConfig {
  accessCode?: string;
  basePath: string;
  enableSession?: boolean;
  graphQlUrl?: string;
  headerChipsEnabled?: boolean;
  homePage?: string;
  includeBaseCss?: boolean;
  isGlobalNavEnabled?: boolean;
  isGuestUser?: boolean;
  language?: string;
  legacySSOUrl?: string;
  loadAdobeScript?: boolean;
  lockEapFilter?: boolean;
  mapLocationUrl?: string;
  portalUrls?: PortalUrl[];
  preSelectEapFilter?: boolean;
  showCost?: boolean;
  showEapFilter?: boolean;
  showMarketPlace?: boolean;
  showOnlineScheduling?: boolean;
  showTreatmentCenter?: boolean;
  showVirtualVisits?: boolean;
  signInUrl?: string;
  theme: string;
  themeOverride?: object;
  themeVersion?: string;
  useOBAPI?: boolean;
  userTier?: string;
  isSsoPortal?: boolean;
}

export enum PortalName {
  UMR = 'umr',
  GEHA = 'geha',
  ALL_SAVERS = 'allsavers',
  STUDENT_RESOURCE = 'studentresources',
  FLEX_WORK = 'flexwork',
  UHONE = 'uhone',
}

export interface PortalData {
  portalName: PortalName;
  portalSource?: PortalSource;
  portalIdentifier?: PortalIdentifier;
  portalConfig: PortalConfig;
  portalEligibilityData?: PortalEligibilityData;
  portalMemberInfo?: PortalMemberInfo | GuestPortalMemberInfo;
}
